/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeformresponselabel3Inputs */

const en_outcomeformresponselabel3 = /** @type {(inputs: Outcomeformresponselabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contractor response so far`)
};

const pt_outcomeformresponselabel3 = /** @type {(inputs: Outcomeformresponselabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta do empreiteiro`)
};

/**
* | output |
* | --- |
* | "Contractor response so far" |
*
* @param {Outcomeformresponselabel3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformresponselabel3 = /** @type {((inputs?: Outcomeformresponselabel3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformresponselabel3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformresponselabel3(inputs)
	return pt_outcomeformresponselabel3(inputs)
});
export { outcomeformresponselabel3 as "outcomeFormResponseLabel" }